import React from 'react';
// import { debugLog } from '../../../../util/logUtils';
import HybridLink from './HybridLink';

const HybridLinkWidget = (props) => {
	const wData = props.data || {},
		data = wData.data || {},
		title = data.title || '',
		linkCards = data.cards || false,
		cardGroup = data.cardGroup || false,
		meta = wData.meta || {},
		titleMeta = meta.title || {},
		layoutDirection = meta.layoutDirection || '',
		groupTitleMeta = meta.groupTitle || false,
		cardGroupHasBorderTop = meta.cardGroupHasBorderTop || false,
		topBorder = (cardGroupHasBorderTop) ? "top-border" : "",
		cardGroupDirection = meta.cardGroupDirection || "vertical",
		cardGroupLayoutClass = (cardGroupDirection === "horizontal") ? "link-group" : "",
		widgetClassMap = (layoutDirection === "horizontal") ? "horizontal-widget" : "",
		displayStyle = meta.displayStyle || "",
		columnClass = meta.columnSize ? `col-${meta.columnSize * 2}` : "",
		columnMdclass = meta.columnSize ? `col-md-${meta.columnSize}` : "";

	return (
		<div className={`hybrid-link-widget ${widgetClassMap} ${displayStyle} ${columnClass} ${columnMdclass}`}>
			{titleMeta.canShow && <div className="title"> {title} </div>}
			{linkCards && <div className={layoutDirection === "horizontal" ? " h-widget " : ""}>
				{linkCards.map((card, index) => {
					return (
						card.type === 'HybridLink' && <HybridLink key={'hlnk-' + index} data={card} />
					);
				})}
			</div>}
			{cardGroup &&
				<div className={cardGroupLayoutClass + " " + topBorder} >{
					cardGroup.map((group, index) => {
						const { data:dataL = {}, meta: groupMeta = {} } = group,
							{ cards = [] } = dataL,
							layoutDirectionGroup = groupMeta.layoutDirection || '',
							groupData = group,
							groupTitle = groupData.title || "";

						return (
							<div key={'hlw-' + index} className={layoutDirectionGroup === "horizontal" ? "d-flex  align-self-center" : ""}>
								{groupTitleMeta.canShow ? <div className="title">{groupTitle}</div> : null}
								{cards.map(card => {
									return (
										card.type === 'HybridLink' && <HybridLink data={card} />
									);
								})}
							</div>);
					})

				}</div>
			}
		</div>
	);
}

export default HybridLinkWidget;